import {
  Logger
} from "./chunk-MG6YGXXR.mjs";

// src/exceptions/exception.ts
var Exception = class extends Error {
  status;
  errors;
  eventId;
  constructor({ error, context, name = "UnnamedException" }) {
    super((error == null ? void 0 : error.message) || "Something went wrong");
    this.name = name;
    const potentialErrors = error;
    this.errors = (potentialErrors == null ? void 0 : potentialErrors.errors) || (potentialErrors == null ? void 0 : potentialErrors.message) || context;
    this.status = context == null ? void 0 : context.status;
    this.eventId = "";
    this.captureError(context);
  }
  async captureError(context) {
    this.eventId = Logger.captureException(this, context) || "";
  }
};

export {
  Exception
};
//# sourceMappingURL=chunk-CQG3BCE6.mjs.map